/**
 * All paths deliberately omit /api (as requested).
 * useFetch is expected to already point to your API base.
 */
export const createQuickSpinService = (api) => ({
  createWheel: (payload) => api.post('/quickspin/wheels', payload),
  updateWheel: (wheelId, payload) => api.put(`/quickspin/wheels/${wheelId}`, payload),
  getWheel: (wheelId) => api.get(`/quickspin/wheels/${wheelId}`),
  getWheels: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return api.get(`/quickspin/wheels${q ? `?${q}` : ''}`);
  },
  deleteWheel: (wheelId) => api.del(`/quickspin/wheels/${wheelId}`),
  getUsage: () => api.get('/quickspin/usage'),
});